<template>
  <div class="container" ref="container">
    <svg
      class="tallyMarks"
      :width="containerWidth"
      :height="containerHeight"
      :viewBox="viewBox"
      ref="svg"
    >
      <TallyMarkGroup
        v-for="group in protoGroups"
        :number="group.count"
        :width="scaledBoxSize.width"
        :height="scaledBoxSize.height"
        :key="'g' + group.count"
      />

      <use
        v-for="(group, i) in groups"
        v-bind="group"
        :xlink:href="'#g' + group.count"
        :key="i"
      />
    </svg>
  </div>
</template>

<script>
/* eslint-disable no-mixed-operators */

import { largestRect } from 'rect-scaler';
import TallyMarkGroup from './TallyMarkGroup';
import {
  NUM_IN_GROUP,
  IMAGE_UPDATE_TIMEOUT_MS,
} from './Constants';


export default {
  name: 'TallyMarks',
  data() {
    return {
      boxWidth: 45,
      boxHeight: 30,
    };
  },
  props: {
    number: { type: Number, required: true },
    containerHeight: { type: Number, required: true },
    containerWidth: { type: Number, required: true },
  },
  computed: {
    viewBox() {
      return `0 0 ${this.containerWidth} ${this.containerHeight}`;
    },
    hMargin() {
      const { containerWidth } = this;
      const { cols, width } = this.scaledBoxSize;
      const delta = containerWidth - cols * width;
      return delta / 2;
    },
    vMargin() {
      const { containerHeight } = this;
      const { rows, height } = this.scaledBoxSize;
      const delta = containerHeight - rows * height;
      return delta / 2;
    },
    scaledBoxSize() {
      const { containerWidth, containerHeight, numGroups, boxWidth, boxHeight } = this;
      const params = largestRect(
        containerWidth,
        containerHeight,
        numGroups,
        boxWidth,
        boxHeight,
      );
      return params;
    },
    protoGroups() {
      // Render one of each count with a component so as to not have to
      // create a massive component hierarchy in Vue.
      const groups = [];
      for (let i = 1; i <= NUM_IN_GROUP; i += 1) {
        groups.push({ count: i });
      }
      return groups;
    },
    numGroups() {
      const { number } = this;
      const fullGroups = Math.floor(number / NUM_IN_GROUP);
      const remainder = number % NUM_IN_GROUP;
      return remainder !== 0 ? fullGroups + 1 : fullGroups;
    },
    groups() {
      const { number, hMargin, vMargin } = this;
      const { width, height, cols } = this.scaledBoxSize;

      const groups = [];
      const fullGroups = Math.floor(number / NUM_IN_GROUP);
      let i = 0;
      for (; i < fullGroups; i += 1) {
        const x = hMargin + (i % cols) * width;
        const y = vMargin + Math.floor(i / cols) * height;
        groups.push({
          count: NUM_IN_GROUP,
          x,
          y,
          width,
          height,
        });
      }

      const remainder = number % NUM_IN_GROUP;
      if (remainder) {
        const x = hMargin + (i % cols) * width;
        const y = vMargin + Math.floor(i / cols) * height;
        groups.push({
          count: remainder,
          x,
          y,
          width,
          height,
        });
      }
      return groups;
    },
  },
  updated() {
    clearTimeout(this.imageUpdateTimeout);
    this.imageUpdateTimeout = setTimeout(() => {
      const svg = this.$refs.svg;
      this.$events.$emit('svgUpdated', new XMLSerializer().serializeToString(svg));
    }, IMAGE_UPDATE_TIMEOUT_MS);
  },
  components: {
    TallyMarkGroup,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  svg {
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/TallyMarks.vue